import React, { useRef, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { motion } from 'framer-motion'
import Sidebar from '../components/layout/Sidebar/index.js'
import MobileNav from '../components/layout/MobileNav'
import Header from '../components/layout/Header'
import { useUIStore } from '../stores/useUIStore'

const MainLayout = ({ children }) => {
  const { isSidebarOpen, setSidebarOpen } = useUIStore()
  const location = useLocation()
  const scrollRef = useRef(null)

  const handleSidebarClose = () => {
    setSidebarOpen(false)
  }

  // Scroll to top on route change
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0
    }
  }, [location.pathname])

  const layoutTransition = {
    type: "spring",
    stiffness: 260,
    damping: 26,
    mass: 0.6,
    restDelta: 0.01
  }

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-900 overflow-hidden">
      {/* 侧边栏 */}
      <motion.div
        layout
        transition={layoutTransition}
        className="relative z-50 lg:z-auto"
      >
        <Sidebar isOpen={isSidebarOpen} />
      </motion.div>

      {/* 移动端导航栏 */}
      <MobileNav />

      {/* 主内容区域 */}
      <motion.div
        layout
        transition={layoutTransition}
        className="flex-1 flex flex-col min-w-0 overflow-hidden"
      >
        {/* 头部导航 */}
        <div className="flex-shrink-0 relative z-30">
          <Header />
        </div>

        {/* 主内容区 */}
        <main className="flex-1 relative overflow-hidden bg-gray-50 dark:bg-gray-900">
          <div
            ref={scrollRef}
            className="absolute inset-0 overflow-y-auto overflow-x-hidden"
            style={{
              WebkitOverflowScrolling: 'touch'
            }}
          >
            <div className="min-h-full">
              <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8 pb-32 lg:pb-8">
                <div className="max-w-7xl mx-auto">
                  {children}
                </div>
              </div>
            </div>
          </div>
        </main>
      </motion.div>
    </div>
  )
}

export default MainLayout
